import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {FormType} from 'src/shared/types'

import {appConfig} from '../shared/config'
import type {Props} from './types'

export const appProps: Props = {
  userInfo: appConfig.launch,
  clientType: 'card',
  country: appConfig.countryCode,
  device: appConfig.device,
  dir: appConfig.dir,
  formType: FormType.Order,
  currency: appConfig.currency,
  lang: appConfig.mapLang,
  location: appConfig.location,
  makeApiUrl: externalApiURL,
  getPhoneMask: appConfig.getPhoneMask,
  normalizePhone: appConfig.normalizePhone,
  accountUrl: appConfig.accountUrl,
  currencySign: appConfig.currencySign,
}
